/* global bocAmchart4, am4core, am4charts, chartLanguage */
/**
 * Get colors for the map from the shortcode or define defaults
 * @param {object} chart object
 * @param {object} fill am4core color passed from amcharts
 * @param {object} target from template adapter, source of data item
 * @returns {object} am4core color
 */
bocAmchart4.calculateHeatmapColors = function (chart, fill, target) {
    var markerCount = 2;
    var index;
    var legendBuckets = bocAmchart4.vars[chart.bocSettings.id].legendBuckets;

    // Override markerCount with user-defined shortcode values
    if (chart.bocSettings.args.hasOwnProperty('markercount')) {
        markerCount = parseFloat(chart.bocSettings.args.markercount);
    }
    // Override maxColorValue with user-defined shortcode value
    if (chart.bocSettings.args.hasOwnProperty('maxcolorvalue')) {
        bocAmchart4.vars[chart.bocSettings.id].maxValue = parseFloat(chart.bocSettings.args.maxcolorvalue);
    }
    // Override minColorValue with user-defined shortcode value
    if (chart.bocSettings.args.hasOwnProperty('mincolorvalue')) {
        bocAmchart4.vars[chart.bocSettings.id].minValue = parseFloat(chart.bocSettings.args.mincolorvalue);
    }

    // Set min and max values either from dataset defaults or user-defined values
    var minValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].minValue);
    var maxValue = parseFloat(bocAmchart4.vars[chart.bocSettings.id].maxValue);

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Using these min/max:",
            "Min value: " + minValue,
            "Max value: " + maxValue,
            "Marker count:" + markerCount
        );
    }

    var mainColors = bocAmchart4.vars[chart.bocSettings.id].mainColors;
    var rect;
    bocAmchart4.vars[chart.bocSettings.id].locale = (chartLanguage === "fr") ? 'fr-CA' : 'en-CA';

    // This condition is to check if legend has already been set up, otherwise it skips directly to assigning a fill colour to the datapoint
    if (bocAmchart4.vars[chart.bocSettings.id].hasOwnProperty("maxLabel")) {
        bocAmchart4.vars[chart.bocSettings.id].maxLabel.text = bocAmchart4.locale(chart, maxValue);
    } else {
        // Create heat legend container and size
        var heatLegend = chart.bottomAxesContainer.createChild(am4core.Container);
        heatLegend.width = am4core.percent(100);
        heatLegend.height = 100;
        heatLegend.align = "right";
        heatLegend.valign = "top";
        heatLegend.layout = "horizontal";

        // Create label container for minimum bucket
        var legendLabelMin = chart.bottomAxesContainer.createChild(am4core.Label);
        legendLabelMin.align = "left";
        legendLabelMin.valign = "bottom";
        legendLabelMin.layout = "horizontal";
        legendLabelMin.marginTop = "-80px";
        legendLabelMin.fontSize = "0.875em";

        // Create label container for maximum bucket
        var legendLabelMax = chart.bottomAxesContainer.createChild(am4core.Label);
        legendLabelMax.align = "right";
        legendLabelMax.valign = "bottom";
        legendLabelMax.fontSize = "0.875em";

        // Array to hold the rectangles for each bucket of values in the legend
        rect = [];
        bocAmchart4.vars[chart.bocSettings.id].allColors = [];

        for (index = 0; index < markerCount; index++) {
            // Create new rectangle for each bucket (based on markerCount)
            rect[index] = heatLegend.createChild(am4core.Rectangle);
            rect[index].width = am4core.percent(100);
            rect[index].height = 15;
            rect[index].strokeWidth = 0;
            if (index === 0) {
                // Assign first colour in mainColours to the first bucket in the legend
                fill = mainColors[index];
            } else if (index === markerCount - 1) {
                // Assign last colour in mainColours to the last bucket in the legend
                fill = mainColors[mainColors.length - 1];
            } else {
                // Find the next gradient colour
                var relValueLegend = (index / (markerCount - 1));
                var arrayRangeLegend = relValueLegend * (mainColors.length - 1);
                var baseIdxLegend = Math.floor(arrayRangeLegend);
                var gradientRangeLegend = arrayRangeLegend - baseIdxLegend;

                fill = am4core.colors.interpolate(
                    mainColors[baseIdxLegend].rgb,
                    mainColors[baseIdxLegend + 1].rgb,
                    gradientRangeLegend
                );
            }

            // Add colour to allColors variable and to rectangle
            bocAmchart4.vars[chart.bocSettings.id].allColors[index] = {
                'color': fill
            };
            rect[index].fill = fill;
        }

        // Assign low and high values to each colour
        var allColors = bocAmchart4.vars[chart.bocSettings.id].allColors;
        allColors[0].low = legendBuckets[0];
        allColors[0].high = legendBuckets[1];
        for (index = 1; index < legendBuckets.length - 1; index++) {
            allColors[index].low = legendBuckets[index];
            allColors[index].high = legendBuckets[index + 1];
        }
        allColors[index - 1].high = legendBuckets[index];

        // Sets up tooltips/labels based on whether min overflow bucket exists
        if (allColors[0].low === false) {
            // Round labels to 2 decimals with minimum value rounding down (i.e. 0.756 rounds down to 0.75)
            let firstBucketLabel = Math.floor(allColors[0].high * 100) / 100;
            legendLabelMin.text = '< ' + bocAmchart4.locale(chart, firstBucketLabel);
            // Updating max legend label here because margin is off if done elsewhere
            legendLabelMax.marginTop = parseFloat(legendLabelMin.marginTop) + 64;
        } else {
            legendLabelMin.text = bocAmchart4.locale(chart, allColors[0].low) + " ≥ \n< "
                + bocAmchart4.locale(chart, allColors[0].high);
            // Updating max legend label here because margin is off if done elsewhere
            legendLabelMax.marginTop = parseFloat(legendLabelMin.marginTop) + 48;
        }
        bocAmchart4.vars[chart.bocSettings.id].minLabel = legendLabelMin;

        // Sets up tooltips/labels based on whether max overflow bucket exists
        if (allColors[allColors.length - 1].high === false) {
            legendLabelMax.text = '≥ ' + bocAmchart4.locale(chart, allColors[allColors.length - 1].low);
            legendLabelMax.html = legendLabelMax.text;
            legendLabelMax.htmlContent = legendLabelMax.text;
            legendLabelMax.textContent = legendLabelMax.text;
        } else {
            legendLabelMax.text = bocAmchart4.locale(chart, allColors[allColors.length - 1].low) + " ≥ \n≤ "
                + bocAmchart4.locale(chart, allColors[allColors.length - 1].high);
            legendLabelMax.textContent = legendLabelMax.text;
            legendLabelMax.html = bocAmchart4.locale(chart, allColors[allColors.length - 1].low) + " ≥ <br>≤ "
                + bocAmchart4.locale(chart, allColors[allColors.length - 1].high);
            legendLabelMax.htmlContent = legendLabelMax.html;

        }

        bocAmchart4.vars[chart.bocSettings.id].maxLabel = legendLabelMax;

        // Set tooltip text for all rectangles with less than/greater than buckets
        rect[0].tooltipText = legendLabelMin.text;
        for (index = 1; index < (markerCount - 1); index++) {
            rect[index].tooltipText = bocAmchart4.locale(chart, allColors[index].low) + " ≥ \n< "
                + bocAmchart4.locale(chart, allColors[index].high);
        }
        rect[index].tooltipText = legendLabelMax.text;
    }

    if (!isNaN(target.dataItem.value)) {
        var value = target.dataItem.value;
        var allColorsMap = bocAmchart4.vars[chart.bocSettings.id].allColors;
        var minOverflowBucket = allColorsMap[0].low;
        var maxOverflowBucket = allColorsMap[allColorsMap.length - 1].high;
        // Get fill color based on value
        fill = bocAmchart4.getFillColor(value, allColorsMap, markerCount, minOverflowBucket, maxOverflowBucket);
    }
    return fill;
};

/**
 * Set up the default Amcharts4 heatmap legend with either default/user-defined colours
 * @param {object} chart object
 * @param {object} series target series
 * @param {object} columnTemplate series column template
 * @returns {void}
 */
bocAmchart4.defaultHeatmapLegend = function (chart, series, columnTemplate) {
    var mainColors = bocAmchart4.vars[chart.bocSettings.id].mainColors;

    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Using these colors:",
            mainColors
        );
    }

    // Set up heat rules for series with either default or user-defined colours
    series.heatRules.push({
        target: columnTemplate,
        property: "fill",
        min: mainColors[0],
        max: mainColors[mainColors.length - 1]
    });

    // Create Amcharts heat legend
    var heatLegend = chart.bottomAxesContainer.createChild(am4charts.HeatLegend);
    heatLegend.width = am4core.percent(100);
    heatLegend.series = series;
    heatLegend.valueAxis.renderer.labels.template.fontSize = "0.563em";
    heatLegend.valueAxis.renderer.minGridDistance = 30;

    // Heat legend behaviour
    series.columns.template.events.on("over", (event) => {
        handleHover(event.target);
    });

    series.columns.template.events.on("hit", (event) => {
        handleHover(event.target);
    });

    /**
     * Show legend tooltip when hovering over a datapoint
     * @param {object} column object
     * @returns {void}
     */
    function handleHover(column) {
        if (!isNaN(column.dataItem.value)) {
            heatLegend.valueAxis.showTooltipAt(column.dataItem.value);
        } else {
            heatLegend.valueAxis.hideTooltip();
        }
    }

    series.columns.template.events.on("out", () => {
        heatLegend.valueAxis.hideTooltip();
    });
};
